/**
 * Estado de un link temporal del Vault — regla PURA compartida por la Lambda pública
 * que lo abre (functions/vault/share-link.ts), el router (mis links / links de una
 * credencial) y el demo del workshop. Entrada `vault-link-status` del catálogo
 * (13/10/2026): antes había tres copias de la misma comparación.
 *
 * Orden de precedencia: revocado gana a todo; después "dormido" (link de onboarding
 * minteado en el alta y todavía no activado: existe, pero no se puede abrir); después
 * vencido; después consumido (un solo uso ya usado).
 */
export type ShareLinkStatus = 'active' | 'dormant' | 'expired' | 'consumed' | 'revoked';

export interface ShareLinkStateFields {
  /** epoch segundos (TTL de DynamoDB) */
  expiresAt: number;
  maxViews: number | null;
  viewCount: number;
  revokedAt?: string;
  /** Link de onboarding que espera el día de ingreso para activarse. */
  dormant?: boolean;
}

export function linkStatus(link: ShareLinkStateFields, now = Date.now()): ShareLinkStatus {
  if (link.revokedAt) return 'revoked';
  if (link.dormant) return 'dormant';
  if (link.expiresAt * 1000 <= now) return 'expired';
  if (link.maxViews !== null && link.viewCount >= link.maxViews) return 'consumed';
  return 'active';
}

/** `expiresAt` (epoch segundos, para el TTL) y su ISO para `hours` horas desde `now`. */
export function shareLinkExpiry(hours: number, now = Date.now()): { expiresAt: number; expiresAtIso: string } {
  const expires = new Date(now + hours * 3_600_000);
  return { expiresAt: Math.floor(expires.getTime() / 1000), expiresAtIso: expires.toISOString() };
}
